import React from 'react';
import { Link } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="relative bg-[#F2E8F0] py-16">
      <div className="container-chisme text-center flex flex-col items-center gap-8">
      
      {/* Social Links - Styled buttons */}
      <div className="flex items-center justify-center gap-4 sm:gap-6">
        <a
          href="https://www.instagram.com/chisme.social/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 px-6 py-3 bg-white border-2 border-gray-200 rounded-full hover:border-[#E1306C] hover:shadow-md transition-all group"
        >
          <svg className="w-6 h-6" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="instagram-gradient" x1="0%" y1="100%" x2="100%" y2="0%">
                <stop offset="0%" style={{stopColor: '#FED373'}} />
                <stop offset="25%" style={{stopColor: '#F15245'}} />
                <stop offset="50%" style={{stopColor: '#D92E7F'}} />
                <stop offset="75%" style={{stopColor: '#9B36B7'}} />
                <stop offset="100%" style={{stopColor: '#515ECF'}} />
              </linearGradient>
            </defs>
            <path fill="url(#instagram-gradient)" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
          </svg>
          <span className="font-semibold text-gray-700 group-hover:text-gray-900">Instagram</span>
        </a>
        
        <a
          href="https://www.tiktok.com/@chisme.social"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 px-6 py-3 bg-white border-2 border-gray-200 rounded-full hover:border-[#010101] hover:shadow-md transition-all group"
        >
          <svg className="w-6 h-6" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="tiktok-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{stopColor: '#25F4EE'}} />
                <stop offset="50%" style={{stopColor: '#FE2C55'}} />
                <stop offset="100%" style={{stopColor: '#000000'}} />
              </linearGradient>
            </defs>
            <path fill="url(#tiktok-gradient)" d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
          </svg>
          <span className="font-semibold text-gray-700 group-hover:text-gray-900">TikTok</span>
        </a>
      </div>

      {/* Center Message */}
      <p className="text-gray-600 text-base">
        Hecho con <span className="text-[#EB42B2]">💜</span> para mujeres en todas partes
      </p>

      <div className="flex justify-center">
        <LanguageSwitcher className="rounded-full backdrop-blur-sm" />
      </div>

      {/* Links */}
      <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-sm text-gray-500">
        <Link to="/terms" className="hover:text-gray-700 transition">
          Terms & Conditions
        </Link>
        <Link to="/privacy" className="hover:text-gray-700 transition">
          Privacy Policy
        </Link>
        <Link to="/guidelines" className="hover:text-gray-700 transition">
          Community Guidelines
        </Link>
      </div>

      {/* Copyright */}
      <div className="text-sm text-gray-500 pt-4 border-t border-gray-200 w-full max-w-md">
        © {new Date().getFullYear()} Chisme. All rights reserved.
      </div>

      {/* Scroll-to-top chevron */}
      <button
        onClick={scrollToTop}
        className="absolute right-8 bottom-8 bg-white shadow-md rounded-full p-2 hover:bg-[#F2E8F0] transition"
        aria-label="Scroll to top"
      >
        <svg className="w-5 h-5 text-[#EB42B2]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
        </svg>
      </button>
      </div>
    </footer>
  );
}
